import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-buttons',
  templateUrl: './shared-buttons.component.html',
  styleUrls: ['./shared-buttons.component.scss']
})
export class SharedButtonsComponent implements AfterViewInit {

  @Input() urlCopiar: any;

  constructor() {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.actualizarIconos();
    });
  }

  private actualizarIconos(): void {
    const iconMap: { [key: string]: string } = {
      'link': '#4361ee',
      'facebook-f': '#1877f2',
      'envelope': '#ea4335',
      'facebook-messenger': 'linear-gradient(135deg, #0099ff 0%, #8b2cff 55%, #ff3b8d 100%)',
      'linkedin-in': '#0a66c2',
      'twitter': '#000000',
      'whatsapp': '#25d366'
    };

    const sbIcons = document.querySelectorAll('.sb-icon');

    sbIcons.forEach((icon: Element) => {
      const svg = icon.querySelector('svg');
      const iconName = svg?.getAttribute('data-icon');

      if (!iconName) {
        return;
      }

      const element = icon as HTMLElement;

      // Messenger: degradado
      if (iconName === 'facebook-messenger') {
        element.style.background =
          'linear-gradient(135deg, #0099ff 0%, #8b2cff 55%, #ff3b8d 100%)';
      }
      // Resto de iconos
      else if (iconMap[iconName]) {
        element.style.background = iconMap[iconName];
      }

      element.style.borderRadius = '10px';
      element.style.color = '#ffffff';

      if (svg) {
        svg.style.color = '#ffffff';
        svg.style.fill = 'currentColor';
      }

      // Reemplazar Twitter por X
      if (iconName === 'twitter') {
        this.reemplazarTwitterPorX(svg);
      }
    });
  }

  private reemplazarTwitterPorX(svg: SVGElement | null): void {
    if (!svg) {
      return;
    }

    svg.innerHTML = `
      <path
        fill="currentColor"
        d="M18.244 2.25h3.308l-7.227 8.26
        8.502 11.24h-6.657l-5.214-6.817
        -5.967 6.817H1.681l7.73-8.835L1.254
        2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161
        17.52h1.833L7.084 4.126H5.117L17.083
        19.77Z"
      />
    `;

    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-label', 'X');
  }
}